import React, { useEffect, useRef } from 'react';

interface IProps {
  label?: string;
  name?: string;
  id?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  style?: React.CSSProperties;

  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  rows?: number;
  cols?: number;
  error?: string;

  isReload?: boolean; //탭으로 구분되어 있는 상태의 화면에서는 resize를 강제 지정해야함
}

const CustomTextarea = (props: IProps) => {
  const [inputValue, setInputValue] = React.useState<string>(props.value || '');
  const ref = useRef<HTMLTextAreaElement | null>(null);

  React.useEffect(() => {
    if (props.value) {
      setInputValue(props.value);
    } else {
      setInputValue('');
    }
  }, [props.value]);

  useEffect(() => {
    if (!props.rows && props.isReload) {
      resize();
    }
  }, [inputValue, props.isReload]);

  const handleOnchange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(e.target.value);
    props.onChange?.(e);
  };

  const resize = () => {
    const el = ref.current;
    if (!el) return;

    const minHeight = props.rows ? props.rows * 24 : 60;

    el.style.height = 'auto'; // 초기화
    el.style.height = `${el.scrollHeight}px`;

    if (el.scrollHeight < minHeight) {
      el.style.height = `${minHeight}px`;
    }
  };

  return (
    <div className={`custom-textarea ${props.className || ''}`} style={props.style}>
      {props.label && <label htmlFor={props.id}>{props.label}</label>}
      <textarea
        id={props.id}
        name={props.name}
        placeholder={props.placeholder}
        value={inputValue}
        onChange={handleOnchange}
        disabled={props.disabled}
        readOnly={props.readOnly}
        rows={props.rows}
        cols={props.cols}
        ref={ref}
        style={{ overflow: `${props.rows ? 'auto' : 'hidden'}` }}
      />
      {props.error && <div className="error-text">{props.error}</div>}
    </div>
  );
};

export default CustomTextarea;
